import { render, staticRenderFns } from "./CreateAndUpdate.vue?vue&type=template&id=af73c6c4&scoped=true"
import script from "./CreateAndUpdate.vue?vue&type=script&lang=js"
export * from "./CreateAndUpdate.vue?vue&type=script&lang=js"
import style0 from "./CreateAndUpdate.vue?vue&type=style&index=0&id=af73c6c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af73c6c4",
  null
  
)

export default component.exports